var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStep4 = function SvgStep4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#026AA2",
    d: "M14.631 23.05v-1.732l6.638-8.677h2.675l-6.542 8.678-1.25-.385h10.677v2.116H14.631Zm7.388 3.06v-3.06l.077-2.116V18.22h2.348v7.888h-2.425Z"
  })));
};
export { SvgStep4 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFMEYyRkUiLz4KPHBhdGggZD0iTTE0LjYzMTEgMjMuMDUwMVYyMS4zMTg1TDIxLjI2OSAxMi42NDFIMjMuOTQzNUwxNy40MDE3IDIxLjMxODVMMTYuMTUxMSAyMC45MzM3SDI2LjgyOTVWMjMuMDUwMUgxNC42MzExWk0yMi4wMTk0IDI2LjEwOTRWMjMuMDUwMUwyMi4wOTY0IDIwLjkzMzdWMTguMjIwOEgyNC40NDM3VjI2LjEwOTRIMjIuMDE5NFoiIGZpbGw9IiMwMjZBQTIiLz4KPC9zdmc+";